/* eslint-disable @typescript-eslint/no-shadow */
import styled from '@emotion/styled'
import {
  Box,
  Button,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  TextField,
  Typography,
} from '@mui/material'
import Image from 'next/image'
import registrationPageBackground from '@asset/game/registration/bg_registration.webp'
import theme from '@theme'

export const BoxRegistrationPageMainWrapper = styled(Box)(() => ({
  backgroundColor: theme.palette.blue14,
  backgroundImage: `url(${registrationPageBackground.src})`,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center top',
}))
export const BoxRegistrationPageSubWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundSize: 'cover',
  height: '100vh',
  '@media (max-width: 991px)': {
    height: '100vh',
  },
  userSelect: 'none',
  overflow: 'auto',
  marginBottom: '15px',
  justifyContent: 'center',
}))

export const SignUpImageChar = styled(Image)(() => ({
  objectFit: 'contain',
  objectPosition: 'bottom right',
  aspectRatio: '3/5',
  justifyContent: 'right',
  alignSelf: 'right',
  maxHeight: '90vh',
  width: '100%',
  height: '100%',
}))

export const ImageContainerBox = styled(Box)(() => ({
  position: 'absolute',
  right: '10%',
  height: '75vh',
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    right: '0%',
  },
  [theme.breakpoints.down('lg')]: {
    right: '2%',
  },
  [theme.breakpoints.up('lg')]: {
    right: '2%',
  },
  [theme.breakpoints.up('xxl')]: {
    right: '10%',
  },
  bottom: 0,
}))

export const TextContaienrBox = styled(Box)(() => ({
  m: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

export const FormFieldsContainerBox = styled(Box)(() => ({
  m: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  backgroundColor: theme.palette.blue14,
  padding: '12px',
  borderRadius: '10px',
}))

export const BoxRegistrationFormTitleMainWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '8px 10px',
  gap: '10px',
  alignSelf: 'stretch',
  borderRadius: '10px',
  background: `linear-gradient(90deg, #42537F 0%, ${theme.palette.blue14} 100%)`,
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

export const TypographyRegistrationFormTitle = styled(Typography)(() => ({
  color: theme.palette.neutralVariant100,
  fontSize: '38px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '57px',
  textAlign: 'center',
  letterSpacing: '-0.02em',
}))

export const TypographyRegistrationFormSubTitle = styled(Typography)(() => ({
  color: theme.palette.neutralVariant100,
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '24px',
  textAlign: 'center',
  letterSpacing: '0.5px',
}))

export const TypographyRegistrationFormTitleWrapper = styled(Typography)(() => ({
  color: theme.palette.neutralVariant100,
  fontSize: '38px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: 'normal',
  textTransform: 'uppercase',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const TypographyRegistrationFormSubTitleWrapper = styled(Typography)(() => ({
  display: 'flex',
  justifyContent: 'center',
  color: theme.palette.purple,
  fontFamily: 'Poppins',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: 700,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
}))

export const TextFieldRegistrationForm = styled(TextField)(() => ({
  borderRadius: '4px',
  border: '1px solid rgba(255, 255, 255, 0.30)',
  background: 'rgba(255, 255, 255, 0.9)',
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.blue14,
    opacity: 0.8,
    textTransform: 'uppercase',
  },
  '& .MuiInputBase-input': {
    color: theme.palette.blue14,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    padding: '10px 12px',
  },
}))

export const FormControlLabelRegistrationForm = styled(FormControlLabel)(() => ({
  color: theme.palette.neutralVariant100,
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 500,
  letterSpacing: '0.5px',
  marginLeft: '-6px',
}))

export const ButtonRegistrationFormSignUp = styled(Button)(() => ({
  borderRadius: '10px',
  background: theme.palette.purple,
  boxShadow: '0px 2px 2px 0px rgba(27, 6, 50, 0.50)',
  color: theme.palette.neutralVariant100,
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  textTransform: 'uppercase',
  padding: '16px',
  ':hover': {
    background: theme.palette.purple1,
  },
  ':disabled': {
    color: theme.palette.blue18,
    background: theme.palette.blue15,
  },
}))

export const BoxRegistrationFormfooterMainWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderEndStartRadius: '10px',
  borderEndEndRadius: '10px',
  background: theme.palette.blue14,
  backdropFilter: 'blur(10px)',
  padding: '0px 0px 15px 5px',
}))

export const TypographyRegistrationFormfooterTitle = styled(Typography)(() => ({
  color: theme.palette.blue15,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
}))

export const TypographyRegistrationFormfooterSubTitle = styled(Typography)(() => ({
  color: theme.palette.blue15,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
}))

export const TypographyAdventurePacks = styled(Typography)(() => ({
  color: theme.palette.neutralVariant100,
  lineHeight: '1.5em',
  fontWeight: '700',
}))

export const TypographyAgeVerification = styled(Typography)(() => ({
  color: theme.palette.neutralVariant100,
  lineHeight: '17px',
  fontWeight: '500',
  fontSize: '12px',
  letterSpacing: '0.5px',
}))

export const TypographyAdventurePacksInfo = styled(Typography)(() => ({
  fontFamily: 'Poppins',
  color: theme.palette.grey2,
  lineHeight: '17px',
  fontWeight: '500',
  fontSize: '12px',
  letterSpacing: '0.5px',
}))

export const BoxRegistrationFormGamTagMainWrapper = styled(Box)(() => ({
  borderRadius: '12px',
  background: theme.palette.blue15,
  backdropFilter: 'blur(5px)',
  padding: '20px 20px 0px 20px',
  minHeight: '90%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  width: '100%',
}))

export const TypographyRegistrationFormGamTagfootertitle = styled(Typography)(() => ({
  color: theme.palette.purple,
  fontFamily: 'Poppins',
  fontSize: '11px',
  fontStyle: 'italic',
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: '0.5px',
}))

export const FormHelperTextRegistrationForm = styled(FormHelperText)(() => ({
  color: `${theme.palette.purple1} !important`,
  fontSize: '13px',
  marginLeft: '5PX',
  fontWeight: 400,
  lineHeight: '23px',
  letterSpacing: '0.5px',
}))

export const NormalLabel = styled(InputLabel)`
  font-weight: bold;
  text-wrap: wrap;
  padding-left: ${({ theme }) => theme.spacing(0.2)};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.neutralVariant100};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 15px;
  color: ${({ theme }) => theme.palette.neutralVariant100};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
`

export const Label = styled(NormalLabel)`
  text-transform: uppercase;

  & .MuiFormLabel-asterisk {
    color: ${({ theme }) => theme.palette.neutralVariant100};
  }
`

export const LoginLink = styled('a')`
  color: ${({ theme }) => theme.palette.neutralVariant100};
  text-decoration: none;
`

export const BoxRegistrationPageMainFormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignSelf: 'center',
  maxHeight: '80vh',
  width: '100%',
  padding: '20px',
}))

export const BoxRegistrationPageSubFormWrapper = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  background: theme.palette.blue16,
  backdropFilter: 'blur(10px)',
}))

export const TypographyForgotPassContainer = styled(Typography)(() => ({
  textAlign: 'right',
  color: theme.palette.blue15,
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  padding: '10px',
}))

export const BoxSignInFormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
}))

export const BoxSignInPageMainWrapper = styled(Box)(() => ({
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  userSelect: 'none',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center top',
}))

export const BoxSignInPageWrapper = styled(Box)(() => ({
  maxHeight: '80vh',
  overflow: 'auto',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  '@media (orientation: landscape)': {
    [theme.breakpoints.down('md')]: {
      maxHeight: '60vh',
    },
  },
}))

export const BoxSignInPageSubWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '10px',
  background: theme.palette.blue16,
  backdropFilter: 'blur(10px)',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px',
  margin: '30px',
  boxShadow: 'rgba(0, 0, 0, 0.04) 0px 5px 15px',
}))

export const BoxLogoWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '32px',
}))

export const CustomRadio = styled(Radio)`
  &.Mui-checked {
    color: ${({ theme }) => theme.palette.purple}; // Customize the checked color
  }
`

export const BoxRegistrationMainWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100%',
  gap: '30px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

export const BoxRegistrationSubWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexBasis: '35%',
  padding: '7%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

export const BoxCharacterMainWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '30%',
  zIndex: 0,
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}))
